export const ALERTS = {
  TITLE: 'Alerts',
  SEARCH_PLACEHOLDER: 'Search alerts...',
  NO_ALERTS_FOUND: 'No alerts found',
  STATUS: {
    OPEN: 'Open',
    CLOSED: 'Closed',
  },
  FILTERS: {
    HOSTNAME: 'Hostname',
    FILTER_BY_HOSTNAME: 'Filter by Hostname',
    CLUSTER: 'Cluster',
    FILTER_BY_CLUSTER: 'Filter by Cluster',
    ALERT_DATE: 'Alert Date',
  },
  MONITORING: {
    LABEL: 'Monitoring',
    HOST_SINGULAR: 'host',
    HOST_PLURAL: 'hosts',
    GROUP_SINGULAR: 'group',
    GROUP_PLURAL: 'groups',
    EVENT_SINGULAR: 'event',
    EVENT_PLURAL: 'events',
    DASHBOARDS: 'Dashboards',
    SECURITY: 'Security',
    STATISTICS: 'Statistics',
    AGENTS: 'Agents',
    DOWNLOAD_AGENT: 'Download Agent',
  },
  DRAWER: {
    CLOSE_ALERT: 'Close Alert',
    DOWNLOAD_RUNBOOK: 'Download runbook',
    CLOSURE_REASON: 'Closure Reason',
    IS_THERE_AFFECTED_DATA: 'Is there affected data?',
    USER_NOTES: 'User Notes',
    FIELDS: {
      HOST: 'Host',
      GROUP: 'Group',
      OCCURRENCES: 'Occurrences',
      LAST_DETECTED: 'Last Detected',
      ADDITIONAL_DETAILS: 'Additional Details',
      RAW_LOG: 'Raw Log',
    },
    EVENTS: 'Events',
    EVENT: 'Event',
  },
  ESCALATION_DIALOG: {
    TITLE: 'Escalate Alert',
    DESCRIPTION: 'You are about to escalate the following alert:',
    WARNING: 'This alert will be forwarded for immediate review.',
    SUCCESS: (alertName: string) => `Alert "${alertName}" escalated successfully`,
    ACTIONS: {
      CANCEL: 'Cancel',
      CONFIRM: 'Confirm Escalation',
    },
  },
  CLOSURE_DIALOG: {
    TITLE: 'Close Alert',
    FIELDS: {
      REASONS_LABEL: 'Reason for closure',
      NOTES_LABEL: 'Additional Notes',
      AFFECTED_DATA_LABEL: 'Is there affected data?',
    },
    REASONS: {
      THREAT_MITIGATED: 'Threat Mitigated',
      ISSUE_RESOLVED: 'Issue Resolved',
      NO_ACTION_REQUIRED: 'No Action Required',
      DUPLICATE_ALERT: 'Duplicate Alert',
      SYSTEM_UPDATED: 'System Update/patched',
      USER_EDUCATED: 'User Educated',
    },
    ACTIONS: {
      CANCEL: 'Cancel',
      CONFIRM: 'Close Alert',
    },
  },
  MESSAGES: {
    CLOSE_SUCCESS: 'Alert closed successfully',
    UPDATE_ERROR: 'Failed to update alert',
  },
}
